{
  "$schema": "https://zam.app/schemas/v1/kvt-tile.json",
  "tile_id": "de-by:realschule-7-deutsch-inhaltsangabe-sachtexte-literatur",
  "version": "2026.08.1",
  "title": "Deutsch 7: Texte erschließen und zusammenfassen – Die Inhaltsangabe, Sachtexte und Balladen (Realschule 7 Bayern)",
  "description": "Geerdetes KVT-Paket für Realschule Bayern Deutsch 7: Methodischer Aufbau der Inhaltsangabe (Basissatz, sachlicher Stil, Präsens, Sinnabschnitte, keine wörtliche Rede), Sachtextanalyse und Balladenuntersuchung.",
  "publisher": "ZAM Curriculum Working Group",
  "published_at": "2026-08-15T23:10:00Z",
  "sources": [
    {
      "uri": "https://www.lehrplanplus.bayern.de/fachlehrplan/realschule/7/deutsch",
      "checked": "2026-08-15",
      "label": "Realschule Deutsch 7, Lernbereiche Texte schreiben und Lesekompetenz"
    }
  ],
  "atoms": [
    {
      "id": "01K4D7N0000000000000000A01",
      "atom_uri": "urn:zam:atom:01K4D7N0000000000000000A01",
      "namespace": "deutsch-texte",
      "slug": "inhaltsangabe-basissatz-praesens-sachlichkeit",
      "title": "Die Inhaltsangabe: Basissatz (TATTE-Formel), sachlicher Stil, Präsens und Verzicht auf wörtliche Rede",
      "domain": "schule/deutsch/texte",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q188",
          "target_label": "Summary (text)",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "deutsch",
          "topic_code": "lb1",
          "topic_title": "Texte schreiben – Informieren",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "deutsch",
          "topic_code": "lb1",
          "topic_title": "Texte schreiben – Informieren",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D7N0000000000000000J01",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "In welcher verbindlichen Zeitform (Tempus) muss eine Inhaltsangabe im Deutschen grundsätzlich verfasst werden?",
          "concept": "Im Präsens (Gegenwart; bei Vorzeitigkeit im Perfekt)",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Im Präsens (Gegenwart)",
              "Im Präteritum (Vergangenheit)"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D7N0000000000000000J02",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Formuliere die 5 verbindlichen Kriterien einer normgerechten Inhaltsangabe: 1. Einleitender **Basissatz (TATTE-Formel)**: Textart, Autor, Titel, Thema/Kernproblem, Erscheinungsjahr/-ort, 2. Hauptteil in **Sinnabschnitten** mit logischen Überleitungen, 3. Sprachlicher Stil: **Präsens als Grundtempus** (Perfekt bei Vorzeitigkeit), sachlich-nüchterne Sprache ohne Wertung/Spannungselemente, eigene Worte, 4. **Strikter Verzicht auf wörtliche Rede** (Umwandlung in indirekte Rede oder sinngemäße Raffung), 5. Kein Schlusskommentar (außer bei ausdrücklich verlangter Deutung) und verfasse einen mustergültigen Basissatz für die Kurzgeschichte 'Die Kirschen' von Wolfgang Borchert (1947).",
          "concept": "Kriterien Inhaltsangabe: 1. Basissatz mit Textart, Autor, Titel, Erscheinungsjahr, Thema (TATTE); 2. Sinnabschnitte; 3. Präsens (Vorzeitigkeit Perfekt), sachlich; 4. Keine wörtliche Rede / Zitate; 5. Objektiv ohne eigene Meinung; Basissatz: In der Kurzgeschichte 'Die Kirschen' von Wolfgang Borchert aus dem Jahr 1947 geht es um ein fieberkrankes Kind, das seinen Vater fälschlicherweise beschuldigt, ihm die letzten Kirschen wegzuesse n.",
          "sample_solution": "1. Die 5 formalen und sprachlichen Kriterien einer Inhaltsangabe: - **1. Der einleitende Basissatz (TATTE-Formel)**:   * Nennt in einem fehlerfreien Satz alle bibliographischen Basisdaten und das zentrale Thema:     - **T**extart (z. B. Kurzgeschichte, Sachtext, Fabel, Novelle)     - **A**utor / Verfasser     - **T**itel des Werkes     - **T**hema / Kernkonflikt in prägnanter Zusammenfassung     - **E**rscheinungsjahr / Erscheinungsort / Quelle. - **2. Der Hauptteil (Chronologische Sinnabschnitte)**:   * Der Text wird in 3–5 inhaltliche Sinnabschnitte unterteilt.   * Wesentliche Handlungsschritte werden in sachlicher Reihenfolge wiedergegeben; Nebenhandlungen, Detailschmuck und Ausschmückungen werden gestrichen (**Textkürzung**). - **3. Das Zeitverhältnis (Tempus)**:   * **Verbindliches Grundtempus ist immer das Präsens** (*'Der Junge liegt im Bett und hört ein Geräusch'*).   * Für vorzeitige Ereignisse (Handlungen, die vor dem aktuellen Geschehen stattfanden) wird zwingend das **Perfekt** verwendet (*'Nachdem er aufgestanden ist, bemerkt er...'*). - **4. Sprachlicher Stil & Indirekte Rede**:   * Nüchterne, sachliche, distanzierte Berichtssprache in **eigenen Worten**.   * **Strikter Verbotstatbestand**: Keine direkte/wörtliche Rede mit Anführungszeichen! Dialoge müssen in **indirekte Rede** im Konjunktiv I bzw. mit 'dass'-Sätzen oder knappen Verben des Sagens zusammengefasst werden (*'Der Vater erklärt, er habe die Schüssel zerbrochen'*). - **5. Objektivität (Keine subjektive Wertung)**:   * In der Inhaltsangabe haben persönliche Meinungen, Wertungen (*'Ich finde...', 'Schrecklicherweise...'*) oder Spannungseffekte nichts zu suchen. 2. Mustergültiger Basissatz: - *„In der 1947 erschienenen Kurzgeschichte ‚Die Kirschen‘ von Wolfgang Borchert geht es um einen fieberkranken Jungen, der seinen fürsorglichen Vater zu Unrecht beschuldigt, heimlich seine Krankenkost aufzuessen.“*"
        }
      ]
    },
    {
      "id": "01K4D7N0000000000000000A02",
      "atom_uri": "urn:zam:atom:01K4D7N0000000000000000A02",
      "namespace": "deutsch-literatur",
      "slug": "ballade-merkmale-drei-gattungen-goethe-fontane",
      "title": "Die literarische Gattung Ballade: Synthese aus Epik, Lyrik und Dramatik ('Dreimäderlhaus der Poesie')",
      "domain": "schule/deutsch/literatur",
      "reduction": "formal",
      "typical_age_min": 12.5,
      "prerequisites": [
        {
          "atom_id": "01K4D7N0000000000000000A01",
          "type": "hard",
          "rationale": "Inhaltsangaben von Balladen setzen das Verständnis ihrer Mehrdimensionalität voraus."
        }
      ],
      "alignments": [
        {
          "target_uri": "http://www.wikidata.org/entity/Q188",
          "target_label": "Ballad",
          "alignment_type": "skos:broadMatch",
          "provenance": "manual_curation_v1"
        }
      ],
      "curricula": [
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "I",
          "subject": "deutsch",
          "topic_code": "lb2",
          "topic_title": "Lesen – Lyrische und epische Texte",
          "exam_relevant": true
        },
        {
          "provider": "lehrplanplus-bayern",
          "school_type": "realschule",
          "grade": 7,
          "track": "II_III",
          "subject": "deutsch",
          "topic_code": "lb2",
          "topic_title": "Lesen – Lyrische und epische Texte",
          "exam_relevant": true
        }
      ],
      "practice_items": [
        {
          "id": "01K4D7N0000000000000000J03",
          "language": "de",
          "tier": "tier1_fast",
          "bloom_level": 1,
          "question": "Warum bezeichnete Johann Wolfgang von Goethe die Ballade als das 'Ur-Ei der Poesie'?",
          "concept": "Weil die Ballade Elemente aller 3 literarischen Grundgattungen (Epik, Lyrik und Dramatik) in einem einzigen Werk vereint",
          "fast_check": {
            "type": "binary_choice",
            "options": [
              "Vereinigung von Epik, Lyrik und Dramatik",
              "Weil sie die älteste Schriftform ist"
            ],
            "correct_index": 0
          }
        },
        {
          "id": "01K4D7N0000000000000000J04",
          "language": "de",
          "tier": "tier2_synthesis",
          "bloom_level": 2,
          "question": "Analysiere die Dreieinigkeit der Ballade anhand konkreter Textbeispiele (z. B. Goethes 'Erlkönig' oder Fontanes 'John Maynard'): 1. **Epische Elemente** (erzählt eine fortlaufende, oft unheimliche oder tragische Geschichte mit Exposition, Konflikt und Höhepunkt/Katastrophe durch einen Erzähler), 2. **Lyrische Elemente** (formale Bindung in Strophen und Verse, Reimschemata wie Kreuzreim/Paarreim, Metrum / Rhythmus wie Jambus/Trochäus, Lautmalerei), 3. **Dramatische Elemente** (lebendige Dialoge mit direkter Figurenrede, Theateratmosphäre, Zuspitzung auf einen existentiellen Entscheidungskonflikt) und unterscheide Volksballaden (mündlich) von Kunstballaden.",
          "concept": "Ballade als Gattungshybrid: Epik (Erzählung/Handlung), Lyrik (Verse, Strophen, Reim, Rhythmus), Dramatik (Dialoge, wörtliche Rede, dramatischer Wendepunkt); Goethe 'Erlkönig' (Erzähler + Dialog Vater/Sohn/Erlkönig + Reime + Tod am Ende).",
          "sample_solution": "1. Die Ballade als Verschmelzung der 3 literarischen Großgattungen: - **1. Epischer Charakter (Das Erzählerische)**:   * Die Ballade erzählt eine in sich geschlossene, oft spannungsgeladene oder unheimliche **Geschichte** mit Anfang, Spannungssteigerung und tragischem/heldenhaftem Ende.   * Eine **Erzählinstanz (Erzähler)** führt in die Handlung ein und schildert Ort, Zeit und Atmosphäre (*'Wer reitet so spät durch Nacht und Wind? Es ist der Vater mit seinem Kind.'*). - **2. Lyrischer Charakter (Das Gedicht)**:   * Das Werk ist in **Strophen und Verse** gegliedert.   * Verwendet feste **Reimschemata** (Paarreim *aabb*, Kreuzreim *abab*, umarmender Reim *abba*), ein rhythmisches **Metrum** (z. B. beschleunigender Daktylus/Anapäst für Hufgeklapper) und klangliche Stilmittel (Alliteration, Assonanz, Lautmalerei). - **3. Dramatischer Charakter (Das Theaterstück / Der Dialog)**:   * Die Handlung wird nicht nur berichtet, sondern durch **wörtliche Rede und szenische Dialoge** der handelnden Figuren direkt aufgeführt (*'Mein Vater, mein Vater, und hörest du nicht, was Erlenkönig mir leise verspricht?'*).   * Hohe Emotionalität, Zuspitzung auf einen **dramatischen Wendepunkt** und Schicksalskampf (Mensch vs. Naturkräfte, Geisterwelt oder Technikkatastrophe wie bei *John Maynard* am brennenden Schiff). 2. Typologie: - **Volksballade**: Mündlich überlieferte, oft gesungene Bänkellieder des Mittelalters über historische Helden oder Verbrechen. - **Kunstballade**: Anspruchsvolle Schöpfung namentlicher Dichter (v. a. im 'Balladenjahr 1797' der Weimarer Klassik von Goethe und Schiller sowie Realismus von Theodor Fontane)."
        }
      ]
    }
  ]
}
